module.exports = __webpack_public_path__ + "img/login-bg.130c84bc.jpg";